import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IHPXMMDataTableRowFormMeta {
  identifier: FormInputMeta;
  name: FormInputMeta;
  isVisible: FormInputMeta;
  image: FormInputMeta;
  menu: FormInputMeta;
  icon: FormInputMeta;
  order: FormInputMeta;
  attachment: FormInputMeta;

  schema: any;
}

const hpxMMDataTabeRowFormMeta = {} as IHPXMMDataTableRowFormMeta;

hpxMMDataTabeRowFormMeta.identifier = {
  name: "identifier",
  type: "text",
  label: "Identifiant",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

hpxMMDataTabeRowFormMeta.name = {
  name: "name",
  type: "select",
  label: "Nom",
  placeholder: "",
  validation: yup.string()
};

hpxMMDataTabeRowFormMeta.isVisible = {
  name: "isVisible",
  type: "checkbox",
  label: "Visible",
  placeholder: "",
  validation: yup.boolean().required("Champ obligatoire !")
};

hpxMMDataTabeRowFormMeta.image = {
  name: "image",
  type: "text",
  label: "Image",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

hpxMMDataTabeRowFormMeta.menu = {
  name: "menu",
  type: "text",
  label: "Menu",
  placeholder: "",
  validation: yup.string()
};

hpxMMDataTabeRowFormMeta.icon = {
  name: "icon",
  type: "text",
  label: "Icon",
  placeholder: "",
  validation: yup.string()
};

hpxMMDataTabeRowFormMeta.order = {
    name: "order",
    type: "number",
    label: "Ordre",
    placeholder: "",
    validation: yup.number().min(0, "Valeur minimale : 0").required("Champ obligatoire !")
};

hpxMMDataTabeRowFormMeta.attachment = {
  name: "attachment",
  type: "select",
  label: "Rattachement",
  placeholder: "",
  validation: yup.string()
};

hpxMMDataTabeRowFormMeta.schema = yup.object().shape(getValidationSchema(hpxMMDataTabeRowFormMeta));

export default hpxMMDataTabeRowFormMeta;